/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_CoachesInputs */

const en_portal_nav_coaches = /** @type {(inputs: Portal_Nav_CoachesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaches`)
};

const pl_portal_nav_coaches = /** @type {(inputs: Portal_Nav_CoachesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy`)
};

/**
* | output |
* | --- |
* | "Coaches" |
*
* @param {Portal_Nav_CoachesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_coaches = /** @type {((inputs?: Portal_Nav_CoachesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_CoachesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_coaches(inputs)
	return en_portal_nav_coaches(inputs)
});